import React, { useState } from 'react';
import ReportFilterBar from '../components/ReportFilterBar';
import ReportDownloadButtons from '../components/ReportDownloadButtons';
import GsecIsinSummaryTable from '../components/GsecIsinSummaryTable';
import { API_BASE_URL } from '../services/api';

// ISIN-wise GSec summary report (own tab).
// Reuses the GSec report API with summaryOnly so downloads contain only the
// ISIN-level summary (ISIN, total face value, weighted average price, weighted yield).
const GsecSummaryReportPage = () => {
  const [filters, setFilters] = useState({});
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasGenerated, setHasGenerated] = useState(false);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleGenerateReport = async (filtersArg) => {
    const usedFilters = filtersArg || filters;
    if (!usedFilters.asAtDate && !usedFilters.isin) {
      setError('Please select an "As at Date" or an ISIN before generating the report.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({ ...usedFilters, summaryOnly: '1' });
      const res = await fetch(`${API_BASE_URL}/reports/gsec?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to fetch report');
      const json = await res.json();
      setSummary(json.summary || []);
      setHasGenerated(true);
    } catch (e) {
      setError(e.message || 'Error fetching report');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (format) => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({ ...filters, summaryOnly: '1', format });
      const res = await fetch(`${API_BASE_URL}/reports/gsec?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to download report');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `t_bond_summary_report.${format === 'excel' ? 'xlsx' : format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError(e.message || 'Error downloading report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gsec-summary-report-page ui-page">
      <h2>T Bond Summary Report (ISIN-wise)</h2>
      <ReportFilterBar
        filters={filters}
        onChange={handleFilterChange}
        onGenerate={handleGenerateReport}
      />
      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
      <ReportDownloadButtons onDownload={handleDownload} disabled={loading || summary.length === 0} />
      {loading && <div style={{ color: '#555', marginBottom: 12 }}>Loading...</div>}
      {!loading && hasGenerated && summary.length === 0 && (
        <div style={{ color: '#6c757d', marginBottom: 12 }}>No data found for the selected filters.</div>
      )}
      <GsecIsinSummaryTable summary={summary} />
    </div>
  );
};

export default GsecSummaryReportPage;
